export type Tag = string;
export type Attributes = Record<string, string>;
export type Content = ContentNode[];
export type NodeText = string | number;
export type NodeTag = {
  tag: Tag;
  attrs: Attributes;
  content?: Content;
};
export type ContentNode = NodeText | NodeTag;

export function parseHtml(html: string, getAssetUrl?: (url: string) => string): Content {
  const parser = new DOMParser();
  const container = parser.parseFromString(`<body>${html}</body>`, "text/html").body;

  const getNodeAst = (node: Element): ContentNode | undefined => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent ?? "";
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const nodeTag: NodeTag = { tag: node.tagName.toLowerCase(), attrs: {}, content: undefined };

      for (const attr of node.attributes) {
        if (getAssetUrl && attr.name === "src") {
          nodeTag.attrs[attr.name] = getAssetUrl(attr.value);
        } else {
          nodeTag.attrs[attr.name] = attr.value;
        }
      }

      const children: Content = [];

      for (const child of node.childNodes) {
        if (child.nodeType === Node.TEXT_NODE) {
          children.push(child.textContent ?? "");
        } else if (child instanceof Element) {
          const childAst = getNodeAst(child);
          if (childAst) {
            children.push(childAst);
          }
        }
      }

      if (children.length > 0) {
        nodeTag.content = children;
      }

      return nodeTag;
    }

    return undefined;
  };

  const containerAst = getNodeAst(container);

  return typeof containerAst === "object" && Array.isArray(containerAst.content) ? containerAst.content : [];
}
